const TelemetryTranslation = {
    SerialNumber:'Сериен номер',
    VendingMachine: 'Кафеварка',
    CoinMechanism: 'Монетник',
    DecimalPoint: 'Десетична точка',
    Ingredients: 'Съставки'
}

export default TelemetryTranslation